module.exports = __webpack_public_path__ + "img/pdf.95c81330.png";